import React from 'react'
import { Label } from 'semantic-ui-react'

export const EquipmentStatusLabel = ({ value }) => {
  const colors = {
    OPERATIONAL: 'green',
    MAINTENANCE: 'yellow',
    FAILED: 'red',
    DECOMMISSIONED: 'grey',
    REPLACED: 'orange',
    AVAIBLE: 'blue'
  }

  const labels = {
    OPERATIONAL: 'Operacional',
    MAINTENANCE: 'Mantenimiento',
    FAILED: 'Defectuoso',
    DECOMMISSIONED: 'Desmantelado',
    REPLACED: 'Reemplazado',
    AVAIBLE: 'Disponible'
  }

  return (
    <Label color={colors[value]} horizontal>
      {labels[value]}
    </Label>
  )
}

export const EquipmentTypeLabel = ({ value }) => {
  if (!value) return null

  return (
    <Label basic color='blue' horizontal>
      {value}
    </Label>
  )
}

export default {
  EquipmentStatusLabel,
  EquipmentTypeLabel,
}